import { ReactNode, useState, createContext, useContext, useMemo } from 'react'

export type PayloadState = 'idle' | 'processing' | 'completed'

type PayloadProcessingStateContextType = {
  payloadState: PayloadState
  setPayloadState: (value: PayloadState) => void
  processingAmount: number | null
  setProcessingAmount: (value: number | null) => void
}

const PayloadProcessingStateContext = createContext<PayloadProcessingStateContextType | undefined>(undefined)

export function usePayloadProcessingState() {
  const context = useContext(PayloadProcessingStateContext)
  if (!context) {
    throw new Error('usePayloadProcessingState must be used within a PayloadProcessingStateProvider')
  }
  return context
}

export function PayloadProcessingStateProvider({ children }: { children: ReactNode }) {
  const [payloadState, setPayloadState] = useState<PayloadState>('idle')
  const [processingAmount, setProcessingAmount] = useState<number | null>(null)
  const value = useMemo(() => ({
    payloadState,
    setPayloadState,
    processingAmount,
    setProcessingAmount
  }), [payloadState, processingAmount]);
  return (
    <PayloadProcessingStateContext.Provider value={value}>
      {children}
    </PayloadProcessingStateContext.Provider>
  )
}
